require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconEyeClosed.tsx
var IconEyeClosed_exports = {};
__export(IconEyeClosed_exports, {
  default: () => IconEyeClosed_default
});
module.exports = __toCommonJS(IconEyeClosed_exports);

// src/assets/monochrome/eyeClosed.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgEyeClosed = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M9.07367 4.41421C9.38052 4.36282 9.69052 4.33725 10.0009 4.33774C12.7828 4.33774 15.3984 6.52671 16.9205 10.073C16.6877 10.6127 16.4248 11.1363 16.1332 11.6407C16.0407 11.7973 15.992 11.98 15.9933 12.1664C15.9952 12.375 16.0596 12.5772 16.1765 12.7421C16.2934 12.907 16.4565 13.0256 16.6409 13.0798C16.8253 13.1339 17.0208 13.1207 17.1977 13.0421C17.3745 12.9635 17.523 12.8238 17.6204 12.6444C18.028 11.9446 18.382 11.2092 18.6789 10.4458C18.7258 10.3266 18.75 10.1981 18.75 10.0683C18.75 9.93842 18.7258 9.80995 18.6789 9.69068C16.9118 5.20759 13.5876 2.42597 10.0009 2.42597C9.59038 2.42371 9.18047 2.46211 8.77624 2.54068C8.66136 2.56202 8.55146 2.60788 8.45279 2.67563C8.35413 2.74338 8.26865 2.83171 8.20123 2.93556C8.13381 3.03941 8.08576 3.15675 8.05984 3.28089C8.03393 3.40503 8.03064 3.53354 8.05017 3.65906C8.0697 3.78459 8.11166 3.90469 8.17367 4.01249C8.23567 4.1203 8.3165 4.21371 8.41154 4.28738C8.50658 4.36105 8.61398 4.41355 8.72758 4.44187C8.84119 4.47019 8.97959 4.44187 9.01718 4.44187L9.07367 4.41421ZM3.95991 2.15612C3.87835 2.06699 3.78152 1.99629 3.67495 1.94806C3.56838 1.89983 3.45416 1.875 3.33881 1.875C3.22346 1.875 3.10925 1.89983 3.00268 1.94806C2.89611 1.99629 2.79928 2.06699 2.71771 2.15612C2.55299 2.33611 2.46044 2.58024 2.46044 2.83479C2.46044 3.08935 2.55299 3.33347 2.71771 3.51347L4.21859 5.10245C2.98126 6.40391 1.99649 7.96434 1.32303 9.69068C1.27486 9.81128 1.25 9.94145 1.25 10.073C1.25 10.2046 1.27486 10.3348 1.32303 10.4554C3.09011 14.9385 6.41431 17.7201 10.0009 17.7201C11.573 17.7082 13.108 17.1967 14.4186 16.248L15.9327 17.8423C16.014 17.9318 16.1107 18.003 16.2173 18.0515C16.3239 18.1 16.4383 18.125 16.5538 18.125C16.6692 18.125 16.7836 18.1 16.8902 18.0515C16.9968 18.003 17.0935 17.9318 17.1749 17.8423C17.2568 17.7534 17.3219 17.6477 17.3663 17.5312C17.4107 17.4147 17.4336 17.2898 17.4336 17.1636C17.4336 17.0374 17.4107 16.9124 17.3663 16.796C17.3219 16.6795 17.2568 16.5738 17.1749 16.4849L3.95991 2.15612ZM8.3126 9.57597L10.4558 11.9179C10.308 11.9642 10.1547 11.9868 10.0009 11.9848C9.53693 11.9848 9.09192 11.7834 8.76381 11.4249C8.4357 11.0663 8.25137 10.5801 8.25137 10.073C8.24958 9.90498 8.27021 9.73753 8.3126 9.57597ZM10.0009 15.8083C7.21912 15.8083 4.60349 13.6194 3.09011 10.073C3.6553 8.7097 4.45747 7.47932 5.45204 6.45024L7.00042 8.16127C6.63672 8.88659 6.49806 9.72121 6.60524 10.5399C6.71242 11.3587 7.05966 12.1173 7.59486 12.7022C8.13007 13.287 8.82438 13.6664 9.57365 13.7835C10.3229 13.9006 11.0867 13.7491 11.7505 13.3517L13.1414 14.8524C12.1889 15.4651 11.1062 15.7946 10.0009 15.8083Z", fill: "#676F7E" }) });
var eyeClosed_default = SvgEyeClosed;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconEyeClosed.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconEyeClosed = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(eyeClosed_default, {}) });
};
IconEyeClosed.displayName = "IconEyeClosed";
var IconEyeClosed_default = IconEyeClosed;
